import EditablePropsType from '../../../types/composer';

export const imageSchema = {
  type: EditablePropsType.Object,
  label: 'Image',
  name: 'image',
  properties: {
    image: {
      type: EditablePropsType.Media,
      name: 'image',
      label: 'Image Source',
      accept: ['image/*'],
    },
    altText: {
      type: EditablePropsType.Text,
      name: 'altText',
      label: 'Alt Text',
    },
    heading: {
      type: EditablePropsType.Text,
      name: 'heading',
      label: 'Heading',
    },
    text: {
      type: EditablePropsType.RichText,
      name: 'text',
      label: 'Text',
    },
    tannerScriptHeading: {
      type: EditablePropsType.Text,
      name: 'tannerScriptHeading',
      label: 'Heading (TannerScript)',
    },
    subheading: {
      type: EditablePropsType.Text,
      name: 'subheading',
      label: 'Subheading',
    },
    url: {
      type: EditablePropsType.Text,
      name: 'url',
      label: 'URL',
    },
    outline: {
      type: EditablePropsType.Boolean,
      name: 'outline',
      label: 'Outline',
      default: false,
    },
    justify: {
      type: EditablePropsType.Select,
      label: 'Text Justify',
      name: 'justify',
      selectOptions: {
        options: [
          { value: 'center', label: 'Center' },
          { value: 'left', label: 'Left' },
          { value: 'right', label: 'Right' },
        ],
      },
      default: 'center',
    },
  },
};

export const imagesSchema = {
  type: EditablePropsType.Array,
  label: 'Images',
  name: 'images',
  items: imageSchema,
};

export default imagesSchema;

export const appLinkImageSchema = {
  type: EditablePropsType.Object,
  label: '',
  name: 'image',
  properties: {
    image: {
      type: EditablePropsType.Media,
      name: 'image',
      label: 'Image Source',
      accept: ['image/*'],
    },
    altText: {
      type: EditablePropsType.Text,
      name: 'altText',
      label: 'Alt Text (leave blank if decorative)',
    },
    text: {
      type: EditablePropsType.RichText,
      name: 'text',
      label: 'Text',
    },
    url: {
      type: EditablePropsType.Text,
      name: 'url',
      label: 'URL',
    },
  },
};

export const appLinkImagesSchema = {
  type: EditablePropsType.Array,
  label: 'Buttons',
  name: 'images',
  items: appLinkImageSchema,
};

export const imageBackgroundSchema = {
  type: EditablePropsType.Object,
  label: 'Background Image',
  name: 'backgroundImage',
  properties: {
    image: {
      type: EditablePropsType.Media,
      name: 'image',
      label: 'Image Source',
      accept: ['image/*'],
    },
  },
};
